import React from 'react';
import ValidationWrapper from '../validation/ValidationWrapper';

function TextAreaInput({
	name,
	value,
	onChange = () => { },
	colors,
	required,
	checkbbdd,
	maxSize,

	/* OPTIONAL PROPS */
	id,
	confirmValue,
	autoComplete = 'off',
	type = 'text',
	placeholder,
	styleINP,
	confirmError,
	classNameINP = 'dynamicInputTextArea w-full leading-6 focus:outline-none text-base resize-none',
}) {
	/* Variable that checks if any point of the component focused */
	const [focus, setFocus] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleINP = {
		backgroundColor: colors?.background,
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleINP = { ...defaultStyleINP, ...styleINP };

	const [dynamicClassNameINP, setDynamicClassNameINP] = React.useState(classNameINP);

	/* Handle on focus */
	const onFocus = event => {
		/* This prevents autocomplete on Chrome */
		if (autoComplete === 'off' && event.target.autocomplete) {
			event.target.autocomplete = 'nothing';
		}
		setFocus(true);
	};
	const [characterCount, setCharacterCount] = React.useState(value?.length);

	React.useEffect(() => {
		setCharacterCount(value?.length);
		if (value?.length > 0) {
			setDynamicClassNameINP('dynamicInputTextArea w-full h-48 leading-6 focus:outline-none text-base resize-none');
		} else {
			setDynamicClassNameINP('dynamicInputTextArea w-full leading-6 focus:outline-none text-base resize-none');
		}
	}, [value]);

	/* Handle on loose focuse */
	const onBlur = () => {
		setFocus(false);
	};

	return <React.Fragment>
		<div className='flex justify-end'>
			<span>
				{characterCount}/{maxSize}
			</span>
		</div>
		<ValidationWrapper
			value={value}
			name={name}
			required={required}
			checkbbdd={checkbbdd}
			colors={colors}
			event={focus}
			showIcons={true}
			confirmValue={confirmValue}
			confirmError={confirmError}
		>
			<textarea
				className={dynamicClassNameINP}
				onChange={event => onChange(event.target.value)}
				value={value}
				type={type}
				id={id}
				style={overrideStyleINP}
				placeholder={placeholder}
				autoComplete={autoComplete}
				onFocus={onFocus}
				onBlur={onBlur}
				maxLength={maxSize}
			/>
			<br />
		</ValidationWrapper>
	</React.Fragment>;
}

export default TextAreaInput;
